module.exports = __webpack_public_path__ + "img/banner-mb.af0c98ad.webp";